module.exports = "/lucky-balls/img/loader-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/loader-1.png
// module id = 1120
// module chunks = 0